import { render, staticRenderFns } from "./index.vue?vue&type=template&id=071d6986&scoped=true&"
import script from "./SortModal.js?vue&type=script&lang=js&"
export * from "./SortModal.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=071d6986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d6986",
  null
  
)

export default component.exports